import { getVisao } from '../util/applicationContext'

export const getFiltroVisaoPorContextoAplicacao = (dados) => ({
  visao: getVisao(dados.codigoUsuario) || dados.visao
})
